export const PromptsAdmin = () => {
  return <div>Prompts Admin</div>;
};
